import { request } from '@/shared/api/request'

export const addSelf = (externalId, person) => {
	return request({ url: `colcontract/tradeUnion/person/addSelf/${externalId}`, method: 'POST', data: person })
}
